import React, { useState, useEffect } from 'react';
import Typography from '../../components/Typography';
import CustomModal from '../../components/CustomModal';
import axios from 'axios';

const EditContractTemplate = () => {
    const [template, setTemplate] = useState('');
    const [loading, setLoading] = useState(false);
    const [openCustomModal, setOpenCustomModal] = useState(false);
    const [customModalType, setCustomModalType] = useState('');
    const [customModalTitle, setCustomModalTitle] = useState('');
    const [customModalMessage, setCustomModalMessage] = useState('');
    const [customModalButtonText, setCustomModalButtonText] = useState('');
    useEffect(() => {
        const fetchTemplate = async () => {
            try {
                const token = localStorage.getItem('token');
                const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/contract/contract-template`, {
                    headers: { Authorization: `Bearer ${token}` },
                });
                setTemplate(res.data.template);
            } catch (err) {
                setCustomModalType('error');
                setCustomModalTitle('ERROR');
                setCustomModalMessage(err.response?.data?.message || 'Failed to fetch template');
                setCustomModalButtonText('OKAY');
                setOpenCustomModal(true);
            }
        };
        fetchTemplate();
    }, []);

    const handleSubmit = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem('token');
            await axios.put(
                `${process.env.REACT_APP_BACKEND_URL}/api/contract/contract-template`,
                { template },
                { headers: { Authorization: `Bearer ${token}` } }
            );
            setCustomModalType('success');
            setCustomModalTitle('TEMPLATE UPDATED!');
            setCustomModalMessage('The contract template has been updated successfully.');
            setCustomModalButtonText('OKAY');
            setOpenCustomModal(true);
        } catch (err) {
            setCustomModalType('error');
            setCustomModalTitle('ERROR');
            setCustomModalMessage(err.response?.data?.message || 'Failed to update template');
            setCustomModalButtonText('OKAY');
            setOpenCustomModal(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='flex flex-col-reverse gap-[14px]'>
            <div className="p-5 rounded-[4px] bg-black">
                <div className="p-4 d-flex flex-col">
                    <Typography text={'Contract Copy Template'} transform={'uppercase'} color={'#FFF'} size={'16px'} weight={400} lineheight={'170%'} family={'Supply'} />
                    <textarea
                        value={template}
                        onChange={(e) => setTemplate(e.target.value)}
                        rows={25}
                        style={{ fontFamily: 'Supply', fontSize: '15px', fontStyle: 'normal',}}
                        className="w-full scrollbar-hide scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-transparent overflow-y-auto overflow-x-auto p-5 mt-[25px] bg-[#1B1B1B] text-white border border-[#262626]"
                    />
                    <div className="flex flex-col justify-end">
                        <button onClick={handleSubmit} disabled={loading} className="mt-4 ml-auto bg-[#DF0F11] text-white px-4 py-2">
                            {loading ? 'Saving...' : 'Save Changes'}
                        </button>
                    </div>
                </div>
                {openCustomModal && (
                    <CustomModal
                        type={customModalType}
                        title={customModalTitle}
                        message={customModalMessage}
                        onClose={() => setOpenCustomModal(false)}
                        onConfirm={() => setOpenCustomModal(false)}
                        colseText={customModalButtonText}
                        cancelButton={customModalType === 'confirm'}
                    />
                )}
            </div>
        </div>
    );
};

export default EditContractTemplate;